import { BTN_RESET_CLASS, TIME_SCORE_TARGET_POINT } from '../constants';
import NPAY_ICON_IMAGE from '../../../assets/images/time-nyang/npay-icon.svg';
import NPayIcon from '../../../assets/icons/badge_npay.svg';

const formatTimeScore = (score) => {
  const safeScore = Math.max(0, Number(score) || 0);
  return safeScore % 1 === 0
    ? safeScore.toLocaleString()
    : safeScore.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
};

export default function TimeNyangScoreCard({ timeScore, canExchangeNPay, onNPayButtonClick }) {
  const progressPercent = Math.min(100, Math.max(0, ((Number(timeScore) || 0) / TIME_SCORE_TARGET_POINT) * 100));

  return (
    <section className="mt-5 rounded-[10px] bg-white p-4 shadow-[0_5px_16px_rgba(0,0,0,0.1)]">
      <div className="flex items-center justify-between px-1 font-['Pretendard'] text-sm font-bold tracking-[-0.5px]">
        <p className="text-gray05">타임스코어</p>
        <p className="text-primary-purple-01">{formatTimeScore(timeScore)} / 3,000</p>
      </div>
      <div className="mt-2.5 h-5 overflow-hidden rounded-[30px] bg-gray01 shadow-[inset_0_2px_4px_rgba(0,0,0,0.15)]">
        <div
          className="h-full bg-gradient-to-b from-primary-blue to-primary-purple-01 shadow-[0_3px_3px_rgba(0,0,0,0.15)]"
          style={{ width: `${progressPercent}%` }}
        />
      </div>
      <div className="mt-2 flex items-center justify-between px-1">
        <p className="font-['Pretendard'] text-xs font-bold tracking-[-0.5px] text-primary-purple-01">
          3,000P 달성 시 상품 교환
        </p>
        <div
          className={canExchangeNPay ? 'time-nyang-npay-active' : ''}
          style={{
            position: 'relative',
            background: canExchangeNPay ? '#03C75A' : '#FFFFFF',
            border: canExchangeNPay ? '0' : '1px solid #D9D9D9',
            borderRadius: canExchangeNPay ? '8px' : '6px',
            padding: canExchangeNPay ? '2px' : '0',
            overflow: 'hidden',
          }}
        >
          {canExchangeNPay ? (
            <div
              className="pointer-events-none absolute inset-0"
              style={{
                background: 'linear-gradient(90deg, transparent 20%, rgba(255,255,255,0.9) 50%, transparent 80%)',
                animation: 'npay-border-shimmer 2s linear infinite',
              }}
            />
          ) : null}
          <button
            type="button"
            onClick={onNPayButtonClick}
            className={`${BTN_RESET_CLASS} flex items-center justify-center gap-[4px]`}
            aria-disabled={!canExchangeNPay}
            style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '6px',
              padding: '6px 10px',
              fontSize: '12px',
              fontWeight: 700,
              letterSpacing: '-0.5px',
              position: 'relative',
            }}
          >
            <img
              src={NPayIcon}
              alt="N Pay"
              className="h-[14px] w-[37px] object-contain"
              style={canExchangeNPay ? undefined : { filter: 'grayscale(1)', opacity: 0.55 }}
            />
            <span style={{ color: canExchangeNPay ? '#5E5E5E' : '#919191', lineHeight: 'normal' }}>2천원권</span>
          </button>
        </div>
      </div>
    </section>
  );
}
